module.exports = __webpack_public_path__ + "static/img/ios.98ca00c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/assets/images/baes/jackpot/ios.png
// module id = cFe2
// module chunks = 43